import styled from 'styled-components';

export const ImageAndNameWrapper = styled.div`
  margin-top: calc(var(--gap) * -1);
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  max-height: 400px;
  display: block;
  aspect-ratio: 256 / 171;
  object-fit: cover;
`;

export const NameWrapper = styled.div`
  padding: 16px 12px;
  background: var(--primary);
  color: var(--white);

  a {
    color: inherit;
  }
`;

export const Name = styled.h2`
  margin-top: 0;
  font-size: 24px;
  white-space: pre-wrap;
`;
